(() => {
    'use strict';
    const forms=document.querySelectorAll('.needs-validation');
    Array.from(forms).forEach(f=>f.addEventListener('submit',e=>{
        if(!f.checkValidity()){e.preventDefault();e.stopPropagation();}
        f.classList.add('was-validated');
    },false));

    const backToTop=document.getElementById('backToTop');
    window.addEventListener('scroll',()=>{backToTop.style.display=window.scrollY>400?'inline-flex':'none';});
    backToTop?.addEventListener('click',()=>window.scrollTo({top:0,behavior:'smooth'}));

    const year=document.getElementById('year'); if(year) year.textContent=new Date().getFullYear();
})();
